import { FilterRuleset } from "./FilterRuleset";

export default FilterRuleset;
